<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card
          header="Attribute"
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-row>
            <b-col md="6" class="my-1">
              <b-form-group label-cols-sm="3" class="mb-0">
                <b-input-group>
                  <b-form-input v-model="filter" placeholder="Type to Search" />
                  <b-input-group-append>
                    <eb-button
                      classic="mr-1 btn-primary"
                      text="Clear"
                      :disabled="!filter"
                      @click="filter = ''"
                    ></eb-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <!-- <b-col md="3" class="my-1">
              <b-form-group label-cols-sm="3" class="mb-0">
                <b-form-select :options="pageOptions" v-model="perPage" />
              </b-form-group>
            </b-col>-->
            <b-col md="3" class="my-1">
              <router-link :to="{ name: 'CreateAttribute' }">
                <eb-button
                  classic="mr-1 btn-primary"
                  text="Create"
                  icon="fa fa-plus-circle mr-1"
                  iconSide="left"
                ></eb-button>
              </router-link>
            </b-col>
          </b-row>
          <b-table
            :dark="dark"
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            responsive="sm"
            :items="attributelist"
            :fields="captions"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            thead-class="header"
            class="mt-3"
            show-empty
            :busy="loading"
            @filtered="onFilter"
          >
            <template slot="action" slot-scope="data">
              <router-link
                :to="{ name: 'ViewAttribute', params: { id: data.item._id } }"
              >
                <b-button size="sm" class="mr-2 mt-2" variant="primary">
                  <i class="fa fa-eye"></i>
                </b-button>
              </router-link>
              <router-link
                :to="{ name: 'AttributeForm', params: { id: data.item._id } }"
              >
                <b-button size="sm" class="mr-2 mt-2" variant="primary">
                  <i class="fas fa-pencil-alt edit"></i>
                </b-button>
              </router-link>
              <b-button
                size="sm"
                class="mr-2 mt-2"
                variant="danger"
                @click="deleteAttribute(data)"
              >
                <i class="fa fa-trash bin"></i>
              </b-button>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </b-table>
          <div style="float: right;">
            <b-pagination
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="filterCount"
              aria-controls="my-table"
              prev-text="Prev"
              next-text="Next"
              hide-goto-end-buttons
            ></b-pagination>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import cTable from "../base/Table.vue";
import axios from "axios";
import { deleteAttribute } from "../../services/attribute.js";
import ebButton from "@/components/FormElements/Button";

export default {
  name: "viewattribute",
  components: {
    cTable,
    ebButton
  },
  data: () => {
    return {
      filterCount:0,
      loading: false,
      items: [],
      tableFields: [
        {
          key: "attributeName",
          label: "Field Name",
          sortable: true
        },
        {
          key: "attributeValueType",
          label: "Type",
          sortable: true
        },
        {
          key: "description",
          label: "Description",
          sortable: true
        },
        {
          key: "action",
          label: "Action"
        }
      ],
      filter: "",
      caption: "Table",
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      tableData: [],
      perPage: 10,
      pageOptions: [5, 10, 15, 20, 25, 30],
      currentPage: 1,
      dark: false
    };
  },
  methods: {
    onFilter(list){
      this.filterCount=list.length
      this.currentPage = 1;
    },
    getRowCount() {
      return this.attributelist.length;
    },
    async deleteAttribute(data) {
      this.$swal({
        title: "Delete this attribute?",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!"
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("attribute/deleteAttribute", data.item._id)
            .then(result => {
              if (result.status === 1) {
                this.$swal({
                  title: "Congratulation",
                  text: "Attribute has been deleted Successfully",
                  type: "success"
                });
                this.$store
                  .dispatch("attribute/getAttributesList")
                  .catch(error => {
                    this.$toasted.error(error.message);
                  });
              } else {
                this.$toasted.error(
                  result.response.data.message
                    ? result.response.data.message
                    : result.response.statusText
                );
              }
            });
        }
      });
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.$store.dispatch("attribute/getAttributesList").catch(error => {
        this.$toasted.error(error.message);
      });
    });
  },
  computed: {
    totalRows() {
      console.log(this.getRowCount());

      return this.getRowCount();
    },
    captions() {
      return this.tableFields;
    },
    attributelist() {
      console.log(this.$store.getters["attribute/GetAttributeList"]);

      return this.$store.getters["attribute/GetAttributeList"];
    }
  }
};
</script>
<style scoped>
.edit {
  color: #ffffff !important;
}
.bin {
  color: white !important;
}
</style>
